import React, { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import { Form, FormActions, FormFields, FormTextField, Stack } from "sprint-common-web";

import { useCreateIntegratorForm } from "./useCreateIntegratorForm";

export interface CreateIntegratorFormProps {
    onCancel(): void;
    onSubmit(): void;
}

export interface CreateIntegratorFormInputs {
    name: string;
}

export const CreateIntegratorForm: FunctionComponent<CreateIntegratorFormProps> = (
    props: CreateIntegratorFormProps
) => {
    const { errors, control, formState, reset, handleSubmit } = useForm<CreateIntegratorFormInputs>({
        defaultValues: {
            name: ""
        },
        criteriaMode: "all"
    });

    const { createIntegrator } = useCreateIntegratorForm();

    const handleCreateIntegrator = async (inputs: CreateIntegratorFormInputs) => {
        await createIntegrator(inputs);
        props.onSubmit();
        reset();
    };

    const handleCancelButtonClick = () => {
        reset();
        props.onCancel();
    };

    return (
        <Form onSubmit={handleSubmit(handleCreateIntegrator)}>
            <Stack verticalAlign="space-between">
                <FormFields>
                    <FormTextField
                        label="Name"
                        control={control}
                        name="name"
                        errors={errors}
                        rules={{
                            required: "Name is required field"
                        }}
                    />
                </FormFields>
                <FormActions
                    isLoading={formState.isSubmitting || formState.isValidating}
                    onCancel={handleCancelButtonClick}
                />
            </Stack>
        </Form>
    );
};
